import {get} from 'lodash';

const refactorRepaymentCalcRates = (pageProps, countryCode) => {
  const financeRates = get(pageProps, 'data.financeRates.nodes[0]', null);
  const countryCodeCapital = countryCode === 'au' ? 'Au' : 'Nz';
  const countryRate = get(financeRates, `acf_finance_rates_${countryCode}.frRepaymentsCalculator${countryCodeCapital}`, null);
  const rates = countryRate ? {
    term: parseFloat(get(countryRate, 'defaultYears', 5)),
    rate: parseFloat(get(countryRate, 'defaultInterestRate', 6.99)),
    disclaimer: get(countryRate, 'disclaimer', null),
    establishmentFee: parseFloat(get(countryRate, 'establishmentFee', 1447)),
    monthlyFee: parseFloat(get(countryRate, 'monthlyFee', 8.90)),

  } : {
    term: 5,
    rate: 6.99,
    disclaimer: null,
    establishmentFee: 1447
  }
  return rates
}

export default refactorRepaymentCalcRates